import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Currency } from 'entities/currencies/model/types';
import { PURGE } from 'redux-persist';
import { RootState } from 'shared/config/store/store';

export type CurrenciesReducer = {
  currencies: Currency[];
};

const initialState: CurrenciesReducer = {
  currencies: [],
};

const currenciesSlice = createSlice({
  name: 'currencies',
  initialState,
  reducers: {
    setCurrencies(state, action: PayloadAction<Currency[]>) {
      state.currencies = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const { setCurrencies } = currenciesSlice.actions;
export default currenciesSlice.reducer;

const selectCurrenciesState = (state: RootState) => state.currencies;

export const getCurrencies = createSelector(
  [selectCurrenciesState],
  (currencies) => currencies.currencies,
);
